import type { TFunction } from "i18next";

/** Backend returns English strings; map to portal i18n keys for toasts. */
const BACKEND_MESSAGE_TO_KEY: Record<string, string> = {
  "RUC is not a registered Electronic Issuer": "onboarding.verifyCompany.rutInvalid",
  "Captcha verification is required": "auth.register.captchaRequired",
  "Captcha verification failed": "auth.register.captchaFailed",
  "User already has a company": "onboarding.verifyCompany.userAlreadyHasCompany",
};

export function translateAuthErrorMessage(
  message: string | undefined,
  t: TFunction
): string | undefined {
  if (message == null || message === "") return undefined;
  // Own-property check, not a bare index: `message` comes from the backend, and
  // a plain object literal resolves "constructor" / "toString" / "__proto__"
  // off Object.prototype — t() would then be handed a FUNCTION as its key.
  const key = Object.prototype.hasOwnProperty.call(BACKEND_MESSAGE_TO_KEY, message)
    ? BACKEND_MESSAGE_TO_KEY[message]
    : undefined;
  return key !== undefined ? t(key) : message;
}
